import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { Activity } from "@mapmycustomers/shared/types/entity";
import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import CheckInsCardData from "@app/scene/dashboard/store/cards/checkIns/CheckInsCardData";
import { DrillDownListFetcherPayload } from "@app/scene/dashboard/types/DrillDownListFetcher";
import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import CheckInsCardConfiguration from "@app/types/dashboard/cards/checkIns/CheckInsCardConfiguration";
import Scope from "@app/types/dashboard/Scope";

export const fetchCheckInsCardData = createAction("@dashboard/fetchCheckInsCardData")<{
  callback: (data: CheckInsCardData) => void;
  configuration: CheckInsCardConfiguration;
  failureCallback?: () => void;
  scope?: Scope;
}>();

export const showCheckInsDrillDown = createAsyncAction(
  "@dashboard/showCheckInsCardDrillDownModal/request",
  "@dashboard/showCheckInsCardDrillDownModal/success",
  "@dashboard/showCheckInsCardDrillDownModal/failure"
)<
  {
    configuration: CheckInsCardConfiguration;
    customDateRange?: DateRange;
    customReliability?: boolean;
    scope: Scope;
  },
  { viewState: DrillDownViewState },
  unknown
>();

export const hideCheckInsDrillDown = createAction(
  "@dashboard/hideCheckInsCardDrillDownModal"
)<void>();

export const fetchCheckInsCardDrillDownData = createAsyncAction(
  "@dashboard/fetchCheckInsCardDrillDownData/request",
  "@dashboard/fetchCheckInsCardDrillDownData/success",
  "@dashboard/fetchCheckInsCardDrillDownData/failure"
)<
  DrillDownListFetcherPayload<Activity>,
  {
    totalFilteredRecords: number;
    totalRecords: number;
  },
  unknown
>();

export const applyCheckInsDrillDownListViewSettings = createAction(
  "@dashboard/applyCheckInsDrillDownListViewSettings"
)<Partial<DrillDownViewState>>();

export const exportCheckInsCardDrillDownData = createAction("@dashboard/exportCheckInsCardData")<{
  configuration: CheckInsCardConfiguration;
  scope: Scope;
}>();

export type CheckInsCardActions = ActionType<
  | typeof applyCheckInsDrillDownListViewSettings
  | typeof exportCheckInsCardDrillDownData
  | typeof fetchCheckInsCardData
  | typeof fetchCheckInsCardDrillDownData
  | typeof hideCheckInsDrillDown
  | typeof showCheckInsDrillDown
>;
